(function () {
    'use strict';

    angular.module('PWAPoCApp').directive('routeStopRowService', routeStopRowService);

    routeStopRowService.$inject = [];

    function routeStopRowService() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/shared/directives/routeStopCard/route-stop-row-service.html',
            transclude: true,
            link: link
        };

        return directive;
        
        function link(scope, element, attrs) {
        }
    }
})();
